<template>
  <v-dialog v-model="dialogMsg" max-width="440px" persistent class="ai-snack">
    <v-card rounded="lg">
      <div class="ai-snack__bar" :style="`background:${barColor};`"></div>
      <v-card-text class="text-center pt-6 pb-2">
        <v-icon size="56" :color="barColor">{{ icone }}</v-icon>
        <h3 class="ai-snack__title mt-3" :style="`color:${barColor};`">{{ this.titulo }}</h3>
        <p class="ai-snack__msg mt-2">{{ this.mensagem }}</p>
      </v-card-text>
      <v-card-actions class="pb-4 px-6">
        <v-spacer></v-spacer>
        <v-btn depressed :color="barColor" dark @click="close()">Fechar</v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  export default {
    data () {
      return {
        color: '',
        mensagem: '',
        titulo: '',
        top: true,
        right: false,
        snackbar: false,
        dialogMsg: false
      }
    },

    computed: {
      barColor() {
        const t = (this.titulo || '').toUpperCase()
        if (t.indexOf('SUCESSO') !== -1 || t.indexOf('INFORMA') !== -1) return '#2e9b5b'
        if (t.indexOf('ATEN') !== -1) return '#f59e0b'
        if (t.indexOf('ERRO') !== -1 || t.indexOf('DESCULPE') !== -1) return '#e53935'
        // fallback: usa a cor recebida se for um hex válido, senão teal
        return /^#?[0-9a-fA-F]{6}$/.test(this.color) ? (this.color[0] === '#' ? this.color : '#' + this.color) : '#038b8b'
      },
      icone() {
        const t = (this.titulo || '').toUpperCase()
        if (t.indexOf('SUCESSO') !== -1 || t.indexOf('INFORMA') !== -1) return 'mdi-check-circle'
        if (t.indexOf('ATEN') !== -1) return 'mdi-alert-circle'
        if (t.indexOf('ERRO') !== -1 || t.indexOf('DESCULPE') !== -1) return 'mdi-close-circle'
        return 'mdi-information'
      },
    },

    methods: {
      snackOld(cor, msg) {
        this.top = true
        this.right = true
        this.color = cor
        this.mensagem = msg
        this.snackbar = true
      },

      close() {
        this.dialogMsg = false
      },

      snack(cor,msg,tit) {
        this.titulo = tit
        this.color = cor
        this.mensagem = msg
        this.dialogMsg = true
      }
    }
  }
</script>

<style scoped>
.ai-snack__bar {
  height: 6px;
  width: 100%;
}
.ai-snack__title {
  font-size: 1.15rem;
  font-weight: 800;
  margin: 0;
}
.ai-snack__msg {
  font-size: 0.98rem;
  color: #5b6478;
  margin: 0;
}
</style>
